import React from 'react';
import {classes} from './SkeletonLineWrapper.st.css';
import {SkeletonLine} from 'wix-ui-tpa/cssVars';

interface SkeletonLineProps {
  size?: string;
  dataHook?: string;
  className?: string;
}

export const SkeletonLineWrapper = ({size, dataHook, className}: SkeletonLineProps) => {
  return <SkeletonLine data-hook={dataHook} className={className ?? classes[size]} />;
};
